import React from 'react'
import Navbar from '../../Components/Navbar'
import QualityHeader from '../../Components/QualityHeader'
import Qualitysystem from '../../Components/Qualitysystem'
import Business from '../../Components/Business'
import Footer from '../../Components/Footer'

const Quality = () => {
  return (
    <div>
      <Navbar/>
      <QualityHeader/>
      <Qualitysystem/>
      <Business/>
      <Footer/>
      
    </div>
  )
}

export default Quality
